// extracted by mini-css-extract-plugin
export default {"banner":"KcAW7BLW3XLPP9ikPAQ_","container":"W5P_WxFtegIGeRdbHC12","title":"JsUoj65ZsvNzTwRkahsg","description":"WAv7ObjdYeQk93j_FxYH"};